import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { RecordInsightsPage } from '~/features/insights/record/record-insights-page';

/** A record's insights, on the grid (boards 08-record-insights and 08-record-insights-offer). */
function InsightsRoute(): ReactElement {
  const { recordId } = Route.useParams();
  return <RecordInsightsPage key={recordId} recordId={recordId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/insights/')({ component: InsightsRoute });
